export const GET_INSTITUTIONS = 'GET_INSTITUTIONS';
export const GET_INSTITUTION_BY_ID = 'GET_INSTITUTION_BY_ID';
export const UPDATE_INSTITUTION = 'UPDATE_INSTITUTION';
export const DELETE_INSTITUTION = 'DELETE_INSTITUTION';
export const CREATE_INSTITUTION = 'CREATE_INSTITUTION';
